import {UseCase} from '@s-ui/domain'

export class GetSearchRequestDealerUseCase extends UseCase {
  constructor({config, getRequestSearchService}) {
    super()
    this._config = config
    this._getRequestSearchService = getRequestSearchService
  }

  execute({query, pageName: context}) {
    return this._getRequestSearchService
      .execute({
        query,
        context
      })
      .then(response => response?.toCleanJSON())
  }
}
